<template>
    <div>
        <b-table head-variant="dark" :fields="table.fields" :items="table.items">
            <template #cell(regra)="data">
                <input-select hide-label :options="options.regra" v-model="data.item.regra"/>
            </template>
            <template #cell(acoes)="data">
                <b-button variant="flat-success" @click="associar(data.item)">
                    <i class="fa-solid fa-link mr-2"></i>
                    Associar proposta
                </b-button>
            </template>
        </b-table>
    </div>
</template>
<script>
import ProjetoService from "@/common/services/projeto/projeto.service"
import helpers from "@/common/utils/helpers"
import {AlertasMixin} from "@/common/mixins/AlertasMixin"
import InputSelect from "@/components/inputs/InputSelect"

export default {
    name: "ProjetoFormulario",
    components: {
        InputSelect
    },
    mixins: [AlertasMixin],
    data: () => ({
        table : {
            items : [],
            fields : [
                {key : "acoes", label: "Ações"},
                {key : "descricaoTecnica.titulo", label: "Titulo"},
                {key : "descricaoTecnica.valorEstimado", label: "Valor estimado",
                    formatter: (value) => {
                        if (value) return helpers.formatarValor(value);
                    },
                },
                {key : "proponente", label: "Proponente"},
                {key : "empresa.nomeFantasia", label: "Executora"},
            ]
        },
        options : {
            regra : helpers.getRegrasProjetos()
        }
    }),
    methods:{
        buscarPropostas: function(){
            ProjetoService.buscarPropostas(this.selectedCompany.id).then(res => {
                this.table.items = res.data.data.itens.map(el => {
                    el.regra = null;
                    return el;
                });
            })
        },

        associar: function(item){
            this.confirmar("Aviso", "Deseja criar um projeto a partir da proposta selecionada?").then(confirma => {
                if(confirma){
                    
                    let form = {
                        propostaId : item.id,
                    }
                    
                    ProjetoService.novoProjeto(form).then(res => {
                        this.alertaSucesso("Sucesso", "Projeto criado com sucesso").then(() => {
                            
                            this.$router.push({ name: "projeto-detalhamento", params: { id : res.data.data } });
                        })
                    }).catch(err => {
                        this.alertaErro(err.response.data.errors);
                    })
                }
            })
        },
    },
    mounted(){
        this.buscarPropostas();
    },
    computed : {
        selectedCompany() {
            return this.$store.state.app.selectedCompanyObj;
        },
    }
}
</script>
<style lang="">
    
</style>